import {
    ApiContentSection,
    ApiSectionType,
    DEFAULT_SPACER_SPACING_PX,
} from '@storefronts/common-types'
import React from 'react'

type SpacerSectionProps = Extract<
    ApiContentSection,
    { type: ApiSectionType.SPACER }
>

export const SpacerSection: React.FC<{ section: SpacerSectionProps }> = ({
    section,
}) => {
    const spacingPx = section.spacingPx ?? DEFAULT_SPACER_SPACING_PX

    return (
        <div
            style={{
                height: spacingPx,
                width: '100%',
            }}
        />
    )
}
